import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import "datatables.net-dt";
import $ from "jquery";
import { baseURL } from "../../axios/common";

const ListReports = () => {
  const [reports, setReports] = useState([]);

  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    if (reports.length) {
      if (!$.fn.DataTable.isDataTable("#ReportsTable")) {
        $("#ReportsTable").DataTable();
      }
    }
  }, [reports]);

  // Fetch Reports List
  const fetchReports = async () => {
    try {
      const response = await axios.get(`${baseURL}admin/getReportsOfAllActivity`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      
      setReports(response.data.data);
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  // Handle block/unblock activity
  const toggleBlockActivity = async (activityId, actionType) => {
    try {
      await axios.post(
        `${baseURL}admin/blockUnblockActivity`,
        { type: actionType, activity_id: activityId },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );

      // Update the UI state
      setReports(prevReports =>
        prevReports.map(report =>
          report.reported_activity_id === activityId
            ? { ...report, is_reported_activity_blocked: actionType === "block" }
            : report
        )
      );
    } catch (error) {
      console.error("Error updating activity status:", error);
      alert("Failed to update activity status.");
    }
  };

  return (
    <div>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid"></div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h2 className="card-title">Reported Activities</h2>
                    </div>
                    <div className="card-body">
                      <table id="ReportsTable" className="table table-striped" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Reported On Activity</th>
                            <th>Reported By</th>
                            <th>Reported For</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports === null ? (
                            <tr>
                              <td colSpan="6" className="text-center">Loading reports...</td>
                            </tr>
                          ) : reports.length === 0 ? (
                            <tr>
                              <td colSpan="6" className="text-center">No reports found</td>
                            </tr>
                          ) : (
                            reports.map((report, index) => (
                                <tr key={report.id}>
                                  <td>{index + 1}</td>
                                  <td>{report.reported_on_activity}</td>
                                  <td>{report.reported_by}</td>
                                  <td>{report.repoted_for}</td>
                                  <td>{report.is_reported_activity_blocked ? "Blocked" : "Not Blocked"}</td>
                                  <td>
                                    <button
                                      onClick={() => toggleBlockActivity(report.reported_activity_id, report.is_reported_activity_blocked ? "unblock" : "block")}
                                      className={`btn btn-sm ${report.is_reported_activity_blocked ? "btn-warning" : "btn-secondary"}`}
                                    >
                                      {report.is_reported_activity_blocked ? "Click here to Unblock" : "Click here to Block"}
                                    </button>
                                  </td>
                                </tr>
                              ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default ListReports;